"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditRangeByProduct = void 0;

var _productTypes = require("../constants/product-types");

const CreditRangeByProduct = {
  [_productTypes.ProductTypes.HOME]: {
    min: 30000,
    max: 3000000
  },
  [_productTypes.ProductTypes.AUTO]: {
    min: 5000,
    max: 150000
  }
};
exports.CreditRangeByProduct = CreditRangeByProduct;